import React, { Component } from 'react';
import { Row, Col, FormGroup, Label, Input, Button, FormFeedback } from 'reactstrap';
import { countries } from '../../helpers/countries';
import { validateCellphone, validateEmail, validateIdNumber, validateName, allValid } from '../../helpers/validation';
import { banks } from '../../helpers/data';

class AddBeneficiaries extends Component {
  constructor (props) {
    super(props);
    this.state = {
      valid: {}
    };
  }

  updateField (path, value) {
    const data = this.props.data;
    path.reduce((acc, curr, i) => {
      if (i === path.length - 1) {
        acc[curr] = value;
        return true;
      } else {
        return acc[curr];
      }
    }, data);
    this.props.setData(data);
  }

  validate () {
    const data = this.props.data;
    const valid = {};
    // console.log(data.beneficiaries)

    const percentagesTotal = data.beneficiaries.reduce((acc, b) => acc + parseInt(b.percentage), 0);
    const percentagesValid = (percentagesTotal === 100) && data.beneficiaries.reduce((acc, b) => {
      const p = parseInt(b.percentage);
      return acc && p && p > 0 && p <= 100;
    }, true);

    valid.beneficiaries = data.beneficiaries.map(b => {
      if (!b) {
        return true;
      } else {
        const bankDetails = b.bankDetails;
        const includePaymentDetails = b.includePaymentDetails;
        const percentage = parseInt(b.percentage);
        const validPercentage = percentage && percentage > 0 && percentage <= 100;
        return {
          firstName: validateName(b.firstName),
          lastName: validateName(b.lastName),
          email: validateEmail(b.email),
          cellphone: validateCellphone(b.cellphone),
          percentage: percentagesValid,
          id: {
            type: true, // assume only valid options
            country: true, // assumer only valid options
            number: b.id.type === 'id'
              ? validateIdNumber(b.id.number)
              : Boolean(b.id.number && b.id.number.length > 0)
          },
          bankDetails: {
            bankName: !includePaymentDetails || (!!bankDetails.bankName && bankDetails.bankName !== 'select'),
            accountType: !includePaymentDetails || validateName(bankDetails.accountType),
            branchCode: !includePaymentDetails || Boolean(bankDetails.branchCode && bankDetails.branchCode.length > 0),
            accountNumber: !includePaymentDetails || Boolean(bankDetails.accountNumber && bankDetails.accountNumber.length > 0)
          }
        };
      }
    });

    this.setState({ valid });

    return allValid(valid);
  }

  isValid (path) {
    const valid = this.state.valid;
    return !this.state.clicked || !!path.reduce((acc, curr) => acc && acc[curr], valid);
  }

  getValue (path) {
    const data = this.props.data;
    return path.reduce((acc, curr) => acc && acc[curr], data);
  }

  componentWillReceiveProps (props) {
    this.validate();
  }

  componentDidMount() {
    this.updateField(['includeBeneficiaries'], true);
  }

  addBeneficiary() {
    const beneficiaries = this.props.data.beneficiaries;
    beneficiaries.push({
      id: {
        type: 'id',
        country: 'ZA'
      },
      bankDetails: {
        type: 'eft',
        accountType: 'cheque_account'
      }
    });
    this.updateField(['beneficiaries'], beneficiaries);
  }

  removeBeneficiary(index) {
    const beneficiaries = this.props.data.beneficiaries;
    beneficiaries.splice(index, 1);
    this.updateField(['beneficiaries', beneficiaries]);
  }

  continue () {
    // const isValid = this.validate();
    // const data = this.props.data;
    // console.log(JSON.stringify(data, null, 2));
    // console.log(JSON.stringify(this.state.valid, null, 2));
    // console.log(isValid);
    this.setState({ clicked: true });
    const isValid = this.validate();

    if (isValid) {
      this.props.nextStep();
    }
  }

  skip () {
    this.updateField(['includeBeneficiaries'], false);
    this.props.nextStep();
  }

  renderBeneficiary(b, index) {
    const basePath = ['beneficiaries', index];
    return <div key={index}>
      <br />
      <span>
      <h5 style={{display: 'inline'}}>Beneficiary {index + 1}</h5>
      {
        index > 0
        ? <Button
            color='link'
            className='float-right p-0'
            onClick={this.removeBeneficiary.bind(this, index)}>
            Remove
          </Button>
      : undefined
      }
      </span>
      <br />
      <br />
      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='firstName'>First name*</Label>
            <Input
              type='text'
              invalid={!this.isValid([...basePath, 'firstName'])}
              value={this.getValue([...basePath, 'firstName'])}
              onChange={e => this.updateField([...basePath, 'firstName'], e.target.value)}
              id='firstName'
              placeholder='Enter first name' />
            <FormFeedback>A valid first name is required</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='lastName'>Last name*</Label>
            <Input
              type='text'
              invalid={!this.isValid([...basePath, 'lastName'])}
              value={this.getValue([...basePath, 'lastName'])}
              onChange={e => this.updateField([...basePath, 'lastName'], e.target.value)}
              id='lastName'
              placeholder='Enter last name' />
            <FormFeedback>A valid last name is required</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='email'>Email address*</Label>
            <Input
              type='text'
              invalid={!this.isValid([...basePath, 'email'])}
              value={this.getValue([...basePath, 'email'])}
              onChange={e => this.updateField([...basePath, 'email'], e.target.value)}
              id='email'
              placeholder='Enter email address' />
            <FormFeedback>A valid email address is required</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='cellphone'>Cellphone number*</Label>
            <Input
              type='text'
              invalid={!this.isValid([...basePath, 'cellphone'])}
              value={this.getValue([...basePath, 'cellphone'])}
              onChange={e => this.updateField([...basePath, 'cellphone'], e.target.value)}
              id='cellphone'
              placeholder='Enter cellphone' />
            <FormFeedback>A valid cellphone number is required</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='percentage'>Payout percentage*</Label>
            <Input
              type='text'
              invalid={!this.isValid([...basePath, 'percentage'])}
              value={this.getValue([...basePath, 'percentage'])}
              onChange={e => {
                if (!parseInt(e.target.value) || parseInt(e.target.value) <= 100) {
                  this.updateField([...basePath, 'percentage'], e.target.value.replace(/\D/,''));
                }
              }}
              id='percentage'
              placeholder='Enter percentage' />
            <FormFeedback>Percentages must add up to 100</FormFeedback>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            <b>Type of identification</b>
          </p>
          <FormGroup>
            <FormGroup check inline>
              <Label check>
                <Input
                  type='radio'
                  checked={this.getValue([...basePath, 'id', 'type']) === 'id'}
                  onChange={() => {}}
                  onClick={e => {
                    this.updateField([...basePath, 'id', 'type'], 'id');
                    this.updateField([...basePath, 'id', 'country'], 'ZA');
                  }}
                />{' '}
              South African ID number
              </Label>
            </FormGroup>
            <FormGroup check inline>
              <Label check>
                <Input
                  type='radio'
                  checked={this.getValue([...basePath, 'id', 'type']) === 'passport'}
                  onChange={() => {}}
                  onClick={e => {
                    this.updateField([...basePath, 'id', 'type'], 'passport');
                  }}
                />{' '}
              Passport number
              </Label>
            </FormGroup>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col sm='6'>
          <FormGroup>
            <Label for='idNumber'>{this.getValue([...basePath, 'id', 'type']) === 'id' ? 'ID' : 'Passport'} number*</Label>
            <Input
              name='idNumber'
              id='idNumber'
              placeholder={'Enter ' + (this.getValue([...basePath, 'id', 'type']) === 'id' ? 'ID' : 'passport') + ' number'}
              invalid={!this.isValid([...basePath, 'id', 'number'])}
              value={this.getValue([...basePath, 'id', 'number'])}
              onChange={e => this.updateField([...basePath, 'id', 'number'], e.target.value)}
            />
            <FormFeedback>A valid {this.getValue([...basePath, 'id', 'type']) === 'id' ? 'ID' : 'passport'} number is required</FormFeedback>
          </FormGroup>
        </Col>
        <Col sm='6'>
          <FormGroup>
            <Label for='country'>Country*</Label>
            <Input
              type='select'
              name='country'
              id='country'
              disabled={this.getValue([...basePath, 'id', 'type']) === 'id'}
              value={this.getValue([...basePath, 'id', 'country']) || 'ZA'}
              onChange={e => this.updateField([...basePath, 'id', 'country'], e.target.value)}
            >
              {countries.map(c => <option key={c.code} value={c.code}>{c.name}</option>)}
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <br />
      <Row>
        <Col sm='6'>
        <FormGroup check inline>
          <Label check>
            <Input
              type="checkbox"
              checked={this.getValue([...basePath, 'includePaymentDetails']) || false}
              onChange={e => this.updateField([...basePath, 'includePaymentDetails'], Boolean(e.target.checked))}
            />{' '}
            Include payment details
          </Label>
        </FormGroup>
        </Col>
      </Row>
      <br/>
      {
        !this.getValue([...basePath, 'includePaymentDetails'])
        ? undefined
        : <div>
            <Row>
              <Col sm='6'>
                <FormGroup>
                  <Label for='bankName'>Bank name</Label>
                  <Input
                    type='select'
                    invalid={!this.isValid([...basePath, 'bankDetails', 'bankName'])}
                    value={this.getValue([...basePath, 'bankDetails', 'bankName']) || 'select'}
                    onChange={e => this.updateField([...basePath, 'bankDetails', 'bankName'], e.target.value)}
                  >
                    <option value='select' disabled>Select bank</option>
                    { banks.map(b => <option
                      key={b.key}
                      value={b.key}>
                      {b.val}
                    </option>)
                    }
                  </Input>
                  <FormFeedback>A valid bank name is required</FormFeedback>
                </FormGroup>
              </Col>
              <Col sm='6'>
                <FormGroup>
                  <Label for='branchCode'>Branch code</Label>
                  <Input
                    name='branchCode'
                    id='branchCode'
                    placeholder='Enter branch code'
                    invalid={!this.isValid([...basePath, 'bankDetails', 'branchCode'])}
                    value={this.getValue([...basePath, 'bankDetails', 'branchCode'])}
                    onChange={e => this.updateField([...basePath, 'bankDetails', 'branchCode'], e.target.value)}
                  />
                  <FormFeedback>A valid branch code is required</FormFeedback>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm='6'>
                <FormGroup>
                  <Label for='accountType'>Account type</Label>
                  <Input
                    type='select'
                    value={this.getValue([...basePath, 'bankDetails', 'accountType'])}
                    onChange={e => this.updateField([...basePath, 'bankDetails', 'accountType'], e.target.value)}
                  >
                    <option key='savings_account' value='savings_account'>Savings</option>
                    <option key='cheque_account' value='cheque_account'>Cheque</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col sm='6'>
                <FormGroup>
                  <Label for='accountNumber'>Account number</Label>
                  <Input
                    name='accountNumber'
                    id='accountNumber'
                    placeholder='Enter account number'
                    invalid={!this.isValid([...basePath, 'bankDetails', 'accountNumber'])}
                    value={this.getValue([...basePath, 'bankDetails', 'accountNumber'])}
                    onChange={e => this.updateField([...basePath, 'bankDetails', 'accountNumber'], e.target.value)}
                  />
                  <FormFeedback>A valid account number is required</FormFeedback>
                </FormGroup>
              </Col>
            </Row>
          </div>
      }
      <hr />
    </div>;
  }

  render () {
    const data = this.props.data;
    return <div>
      <h1>Add beneficiaries</h1>
      <br />
      <p>
        Should anything happen to you, it is important that the proceeds of your cover pass seamlessly to your loved ones,
        which is why we advise that you add your beneficiaries now.
      </p>
      {data.beneficiaries.map((b, i) => this.renderBeneficiary(b, i))}
      <Button color='link' onClick={this.addBeneficiary.bind(this)}>+ Add another beneficiary</Button>
      <br />
      <br />
      
      <Button color='primary' className='px-5' onClick={this.continue.bind(this)}>Continue</Button>
      <Button color='link' onClick={this.props.previousStep}>Back</Button>
      <Button color='link' onClick={this.skip.bind(this)} style={{ float: 'right' }}>Skip for now</Button>
    </div>;
  }
}

export default AddBeneficiaries;



// WEBPACK FOOTER //
// ./src/components/application/add-beneficiaries.js